import React, { useEffect, useRef, useState } from "react";
import LineScroll from "../SvgIcons/LineScroll";
import "./style.scss";

export default function CollabTab() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Trigger when 10% of the section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setIsVisible(entry.isIntersecting);
      });
    }, options);

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);
  return (
    <section className="CollabTab-main" ref={sectionRef}>
      <div className="container">
        <div className="lineanimation">
          <LineScroll isVisible={isVisible} />
        </div>
        <div className="collabtab-box">
          <div className="collabtab-leftside" data-aos="fade-in">
            <h3>CollabTab™</h3>
            <h4>Intertwine shared events with others.</h4>
            <p>
              Build richer memories! Instantly invite your friends and family to
              collaborate on shared events. CollabTab™ is the best way to
              gain new perspectives and share photos, videos, and text,
              intertwining and aligning your history with those who matter most.
              View your friends’ and family’s photos, videos, and memories of a
              shared event or experience simply by clicking on their profile
              picture.
            </p>
            {/* <p>
              See your friend's and family's photos, videos, and memories of a
              shared event or experience simply by clicking on their profile
              picture.
            </p> */}
          </div>
          <div className="collabtab-rightside" data-aos="fade-in">
            <img
              src="../images/collabtab.png"
              alt="The CollabTab"
              className="img-fluid"
            />
          </div>
        </div>
        <div className="collabtab-box pastPuller">
          <div className="collabtab-rightside" data-aos="fade-in">
            <img
              src="../images/pastpuller.png"
              alt="The CollabTab"
              className="img-fluid"
            />
          </div>
          <div className="collabtab-leftside" data-aos="fade-in">
            <h3>PastPuller™</h3>
            <h4>Import memories from other places</h4>
            <p>
              PastPuller™ is one of Paths most powerful features. It allows
              you to pull in all your current and past posts from Facebook,
              Instagram, Blogger, and MySpace. Revive those old memories and
              keep them alive on your timeline, enabling you to reconnect with
              the people you shared those moments with. Paths provides a safe
              space to preserve, revive, and share your history. Be sure to back
              up your social media body of work—your memories!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
